<script>
import { canEditAttendanceMoneyFields } from "@/helpers/userPermissions"
import { resolveCodeTaxId } from "@/helpers/attendance-code-tax"
import { FormWizard, TabContent } from "vue-form-wizard"
import Multiselect from "vue-multiselect"

export default {
  props: {
    currentUser: { type: Object, required: true },
    currentEmpresa: {type: Object, required: true},
    listAgreements: { type: Array },
    listApproachs: { type: Array },
    listCodesTax: { type: Array },
    listPacients: { type: Array },
    listPrices: { type: Array, required: true },
    listProfessionals: { type: Array },
    listSpecialties: { type: Array },
    listTiposPagamento: { type: Array },
  },
  components: { Multiselect, FormWizard, TabContent },
  data() {
    return {
        titleBody: "Inserindo",
        searchPacient: "",
        searchProfessional: "",
        searchAgreement: "",
        pacients: [],
        professionals: [],
        agreements: [],
        specialties: [],
        approachs: [],
        codesTax: [],
        selectedAgreement: null,
        selectedTratament: null,
        selectedTipoPagamento: null,
        sessionQuantityError: null,
        service: {
            pacient_id: null,
            professional_id: null,
            agreement_id: null,
            treatment_id: null,
            code_tax_id: null,
            approach_id: null,
            responsible_id: null,
            service_value: null,
            transfer_amount: null,
            coparticipation_amount: null,
            recurrence: "WEEKLY",
            control_sessions: false,
            session_quantity: null,
        },
    }
  },
  created() {
    this.agreements     = this.listAgreements
    this.approachs      = this.listApproachs
    this.codesTax       = this.listCodesTax
    this.pacients       = this.listPacients
    this.professionals  = this.listProfessionals
    this.specialties     = this.listSpecialties
    this.tiposPagamento = this.listTiposPagamento
  },
  mounted() {
    this.$emit("newTitle", "Incluir Atendimento")
  },
  computed: {
    permission() {
      return canEditAttendanceMoneyFields(this.currentUser)
    },
    isPrivate() {
      return this.service.pacient ? this.service.pacient.is_private : null
    },
  },
  methods: {
    back() {
      this.$emit("back");
    },
    filterPacient(nome) {
      if (!nome) {
        this.pacients = this.listPacients
      } else {
        this.pacients = this.listPacients.filter(p =>
          p.nome.toLowerCase().includes(nome.toLowerCase())
        )
      }
    },
    filterProfessional(name) {
      if (!name) {
        this.professionals = this.listProfessionals
      } else {
        this.professionals = this.listProfessionals.filter(p =>
          p.name.toLowerCase().includes(name.toLowerCase())
        )
      }
    },
    filterAgreements(name){
      if (!name) {
        this.agreements = this.listAgreements
      } else {
        this.agreements = this.listAgreements.filter(a =>
          a.name.toLowerCase().includes(name.toLowerCase())
        )
      }
    },
    onAgreementSelected(agreement) {
      this.service.agreement_id = agreement?.id || null
      this.applyCodeTaxFromSelections()
      this.setPrice()
    },
    onTratamentSelected(specialty) {
      console.log(specialty)
      this.service.treatment_id = specialty?.id || null
      this.applyCodeTaxFromSelections()
      this.setPrice()
    },
    applyCodeTaxFromSelections() {
      this.service.code_tax_id = resolveCodeTaxId({
        agreement: this.service.agreement,
        specialty: this.selectedTratament,
      })
    },
    onTipoPagamentoSelecionado(tipoPagamento) {
      this.service.tipo_pagamento_id = tipoPagamento?.id || null
    },
    setAgreement(agreement) {
      if (agreement === this.service.agreement) {
        this.service.agreement_id = null
        this.service.agreement = null
        this.searchAgreement = ""
        return
      }

      this.service.agreement_id = agreement.id
      this.service.agreement    = agreement
      this.searchAgreement = agreement.name
      this.applyCodeTaxFromSelections()
      this.$refs.wizard.nextTab()
    },
    setPacient(pacient) {
      if (pacient === this.service.pacient) {
        this.service.pacient_id = null
        this.service.pacient = null
        this.searchPacient = ""
        return
      }

      this.service.pacient_id = pacient.id
      this.service.pacient = pacient
      // filter agreements by paciente.agreements
      const listInPacient = this.listAgreements.filter(agreement => pacient.agreements.some(a => a.id === agreement.id))
      this.agreements = listInPacient
      this.searchPacient = pacient.nome
      
      if (listInPacient.length === 1) {
        this.setAgreement(listInPacient[0])
        this.$refs.wizard.changeTab(0, 2)
      } else {
        this.$refs.wizard.nextTab()
      }
    },
    setPrice() {
      // Aplicar o preço filtrando tratamento e convênio
      console.log(this.service)
      if (this.service?.treatment_id && this.service?.agreement_id) {
        let price = this.listPrices?.filter((item) => {
          return (
            item.specialty_id == this.service.treatment_id &&
            item.agreement_id == this.service.agreement_id
          )
        })

        if (price.length > 0) {
          this.service.service_value   = this.formatterFloatBR(price[0].service_value)
          this.service.transfer_amount = this.formatterFloatBR(price[0].transfer_amount)
        }
      }
    },
    setPost() {
      if (!this.validateAttendanceData()) {
        return
      }

      const controlSessions = Boolean(this.service.control_sessions)

      this.$emit(
        "doPost",
        {
          service_value: this.new_convert_srting_float(this.service.service_value),
          transfer_amount: this.new_convert_srting_float(this.service.transfer_amount),
          coparticipation_amount: this.new_convert_srting_float(this.service.coparticipation_amount),
          contact: this.service.contact,
          local: this.service.local,
          treatment_id: this.service.treatment_id,
          approach_id: this.service.approach_id,
          responsible_id: this.service.responsible_id,
          agreement_id: this.service.agreement_id,
          pacient_id: this.service.pacient_id,
          professional_id: this.service.professional_id,
          empresa_id: this.currentEmpresa.id,
          start_date: this.service.start_date,
          end_date: this.service.end_date,
          start_time: this.service.start_time,
          end_time: this.service.end_time,
          recurrence: this.service.recurrence,
          specialty_id: this.service.specialty_id,
          code_tax_id: this.service.code_tax_id,
          tipo_pagamento_id: this.service.tipo_pagamento_id,
          control_sessions: controlSessions,
          session_quantity: controlSessions ? Number(this.service.session_quantity) : null,
        }
      )
    },
    onSessionControlChange() {
      if (!this.service.control_sessions) {
        this.service.session_quantity = null
        this.sessionQuantityError = null
      }
    },
    validateAttendanceData() {
      if (!this.service.control_sessions) {
        this.sessionQuantityError = null
        return true
      }

      const quantity = Number(this.service.session_quantity)
      if (!Number.isInteger(quantity) || quantity < 1) {
        this.sessionQuantityError = 'Informe uma quantidade mensal inteira maior que zero.'
        return false
      }

      this.service.session_quantity = quantity
      this.sessionQuantityError = null
      return true
    },
    clearSessionQuantityError() {
      this.sessionQuantityError = null
    },
    setProfessional(professional) {
      if (professional === this.service.professional) {
        this.service.professional_id = null
        this.service.professional = null
        this.searchProfessional = ""
        return
      }

      this.service.professional_id = professional.id
      this.service.professional    = professional
      this.specialties             = professional.specialty;
      this.selectedTratament       = professional.specialty[0] || null
      this.service.treatment_id = this.selectedTratament?.id || null
      this.applyCodeTaxFromSelections()
      this.searchProfessional = professional.name
      this.$refs.wizard.nextTab()
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <FormWizard
                  ref="wizard"
                  color="#556ee6"
                  back-button-text="Voltar"
                  next-button-text="Avançar"
                  finish-button-text="Gravar Atendimento"
                  @on-complete="setPost"
                >
                    <tab-content title="Selecionar Paciente" icon="mdi mdi-face-profile">
                      <h2>Selecionar Paciente</h2>
                      <b-row cols="1">
                       <div class="position-relative">
                         <form class="app-search d-none d-lg-block" @submit.prevent>
                           <div class="position-relative">
                             <input
                               v-model="searchPacient"
                               name="pacient"
                               type="text"
                               class="form-control"
                               placeholder="Buscar por nome do Paciente"
                               @input="filterPacient($event.target.value)"
                             />
                             <span class="ri-search-line"></span>
                           </div>
                         </form>
                       </div>
                      </b-row>
                      <div class="row">
                          <div class="col-12 max-h-96 overflow-y-auto">
                              <!-- loop array pacients -->                               
                              <b-row cols="1" v-for="pacient in pacients" :key="pacient.id" class="cursor-pointer">
                                <b-col @click="setPacient(pacient)">
                                  <b-card class="flex" :class="(service.pacient_id === pacient.id) ? 'bg-light' : 'bg-default'">
                                    <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                                      <span class="text-lg font-semibold">{{ pacient.nome.substring(0, 1) }}</span>
                                    </b-badge>
                                    <span class="flex items-center ml-3">
                                      {{ pacient.nome }} - <i class="ri-phone-line"></i> {{ (pacient.contact) ? pacient.contact : '' }} | <i class="ri-mail-line"></i> {{ pacient.responsible ? pacient.responsible.email : '' }}
                                    </span>
                                  </b-card>
                                </b-col>
                              </b-row>
                          </div>
                      </div>
                    </tab-content>
                    <tab-content title="Selecionar Convênio" icon="mdi mdi-handshake">
                      <h2>Selecionar Convênio</h2>
                      <b-row cols="1">
                       <div class="position-relative">
                         <form class="app-search d-none d-lg-block" @submit.prevent>
                           <div class="position-relative">
                             <input
                               v-model="searchAgreement"
                               name="agreements"
                               type="text"
                               class="form-control"
                               placeholder="Buscar por nome do Covênio"
                               @input="filterAgreements($event.target.value)"
                             />
                             <span class="ri-search-line"></span>
                           </div>
                         </form>
                       </div>
                      </b-row>
                      <div class="row">
                        <div class="col-12 max-h-96 overflow-y-auto">
                            <!-- loop array pacients -->
                            <b-row cols="1" v-for="agreement in agreements" :key="agreement.id" class="cursor-pointer">
                              <b-col @click="setAgreement(agreement)">
                                <b-card class="flex" :class="(service.agreement_id === agreement.id) ? 'bg-light' : 'bg-default'">
                                  <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                                    <span class="text-lg font-semibold">{{ agreement.name.substring(0, 1) }}</span>
                                  </b-badge>
                                  <span class="flex items-center ml-3">
                                    {{ agreement.name }}
                                  </span>
                                </b-card>
                              </b-col>
                            </b-row>
                        </div>
                      </div>
                    </tab-content>
                    <tab-content title="Selecionar Profissional" icon="mdi mdi-account-circle">
                      <h2>Selecionar Profissional</h2>
                      <b-row cols="1">
                       <div class="position-relative">
                         <form class="app-search d-none d-lg-block" @submit.prevent>
                           <div class="position-relative">
                             <input
                               v-model="searchProfessional"
                               name="professional"
                               type="text"
                               class="form-control"
                               placeholder="Buscar por nome do Profissional"
                               @input="filterProfessional($event.target.value)"
                             />
                             <span class="ri-search-line"></span>
                           </div>
                         </form>
                       </div>
                      </b-row>
                      <div class="row">
                        <div class="col-12 max-h-96 overflow-y-auto">
                            <!-- loop array pacients -->
                            <b-row cols="1" v-for="professional in professionals" :key="professional.id" class="cursor-pointer">
                              <b-col @click="setProfessional(professional)">
                                <b-card class="flex" :class="(service.professional_id === professional.id) ? 'bg-light' : 'bg-default'">
                                  <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                                    <span class="text-lg font-semibold">{{ professional.name.substring(0, 1) }}</span>
                                  </b-badge>
                                  <span class="flex items-center ml-3">
                                    {{ professional.name }} - <b-badge v-for="specialty in professional.specialty" :key="specialty.id">{{ specialty.name }}</b-badge>
                                  </span>
                                </b-card>
                              </b-col>
                            </b-row>
                        </div>
                      </div>
                    </tab-content>
                    <tab-content
                      title="Dados do atendimento"
                      icon="mdi mdi-checkbox-marked-circle-outline"
                      :before-change="validateAttendanceData"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <b-card bg-variant="light" border-variant="light" title="Resumo da seleção">
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-4">
                                  <p class="text-sm text-slate-500">Paciente:</p>
                                  <p><strong>{{ (service.pacient) ? service.pacient.nome : 'Não selecionado' }}</strong></p>
                                </div>
                                <div class="col-md-4" v-if="service.professional">
                                  <p class="text-sm text-slate-500">Profissional:</p>
                                  <p><strong>{{ service.professional.name }}</strong></p>
                                  <p v-for="specialty in service.professional.specialty" :key="specialty.id"
                                      class="text-sm text-slate-400 capitalize"
                                  >{{ specialty.name }}</p>
                                </div>
                                <div class="col-md-4" v-if="service.agreement">
                                  <p class="text-sm text-slate-500">Covênio:</p>
                                  <p><strong>{{ service.agreement.name }}</strong></p>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="card">
                            <div class="card-body">
                              <div class="row">
                                <div class="form-group col-md-4">
                                  <label for="specialty_id">Tratamento:</label>
                                  <Multiselect
                                    v-model="selectedTratament"
                                    :options="specialties"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :preserve-search="true"
                                    :show-labels="false"
                                    placeholder="Selecione o tratamento"
                                    label="name"
                                    track-by="id"
                                    @input="onTratamentSelected"
                                  >
                                    <template slot="singleLabel" slot-scope="props">
                                      <strong>{{ props.option.id }}</strong> - {{ props.option.name }}
                                    </template>
                                    <template slot="option" slot-scope="props">
                                      <strong>{{ props.option.id }}</strong> - {{ props.option.name }}
                                    </template>
                                  </Multiselect>
                                </div>
                                <div class="form-group col-md-4">
                                  <label for="approach_id">Abordagem:</label>
                                  <select
                                    class="custom-select mr-sm-2"
                                    id="selectApproach"
                                    v-model="service.approach_id"
                                  >
                                    <option value="-1" selected="selected">
                                      Selecione a abordagem
                                    </option>
                                    <option
                                      v-for="(item, index) in approachs"
                                      :key="index"
                                      :value="item.id"
                                    >
                                    {{ item.id }} - {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <div class="form-group col-md-2">
                                  <label for="localAtendimento">Local do atendimento:</label>
                                  <input
                                    id="localatendimento"
                                    type="text"
                                    class="form-control"
                                    placeholder="Local de atendimento"
                                    v-model="service.local"
                                  />
                                </div>
                              </div>
                              <div class="row">
                                <h4 class="card-title col-md-12">Período recorrência</h4>
                                <p class="col-md-12">Defina o período de recorrência do Atendimento</p>
                                <div class="form-group col-md-2">
                                  <b-form-group label="Tipo de recorrência:" v-slot="{ ariaDescribedby }">
                                    <b-form-radio v-model="service.recurrence" :aria-describedby="ariaDescribedby" name="recurrence" value="none">Nunca</b-form-radio>
                                    <b-form-radio v-model="service.recurrence" :aria-describedby="ariaDescribedby" name="recurrence" value="WEEKLY">Semanal</b-form-radio>
                                  </b-form-group>
                                </div>
                                <div class="form-group col-md-3">
                                  <label for="start_date">Data início:</label>
                                  <input
                                    name="start_date"
                                    type="date"
                                    class="form-control"
                                    required
                                    v-model="service.start_date"
                                  />
                                </div>
                                <div class="form-group col-md-2">
                                  <label for="start_time">Hora início:</label>
                                  <input
                                    name="start_time"
                                    type="time"
                                    class="form-control"
                                    required
                                    v-model="service.start_time"
                                  />
                                </div>
                                <div class="form-group col-md-2">
                                  <label for="end_time">Hora fim:</label>
                                  <input
                                    name="end_time"
                                    type="time"
                                    class="form-control"
                                    v-model="service.end_time"
                                  />
                                </div>
                                <div class="form-group col-md-3">
                                  <label for="end_date">Data fim:</label>
                                  <input
                                    name="end_date"
                                    type="date"
                                    class="form-control"
                                    v-model="service.end_date"
                                  />
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-md-4 mb-0">
                                  <b-form-checkbox
                                    v-model="service.control_sessions"
                                    switch
                                    @change="onSessionControlChange"
                                  >
                                    Limitar atendimentos por mês
                                  </b-form-checkbox>
                                  <small class="form-text text-muted">
                                    Considera as recorrências não canceladas deste atendimento no mês.
                                  </small>
                                </div>
                                <div v-if="service.control_sessions" class="form-group col-md-3 mb-0">
                                  <label for="session_quantity">Quantidade mensal:</label>
                                  <input
                                    id="session_quantity"
                                    v-model.number="service.session_quantity"
                                    type="number"
                                    min="1"
                                    step="1"
                                    required
                                    class="form-control"
                                    :class="{ 'is-invalid': sessionQuantityError }"
                                    placeholder="Ex.: 4"
                                    @input="clearSessionQuantityError"
                                  />
                                  <div v-if="sessionQuantityError" class="invalid-feedback">
                                    {{ sessionQuantityError }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </tab-content>
                    <tab-content title="Dados financeiros" icon="mdi mdi-currency-brl">
                      <h2>Informações financeiras</h2>
                      <div class="form-row col-md-12 mt-4">
                        <div class="form-group col-md-4" :class="(this.service.agreement && !this.service.agreement.is_private) ? 'col-md-4' : 'col-md-6'">
                          <label for="code_tax_id">Código Fiscal do Serviço:</label>
                          <select
                            v-model="service.code_tax_id"
                            class="form-control"
                            id="code_tax_id"
                          >
                            <option value="" selected>
                              Selecione o código
                            </option>
                            <option
                              v-for="codetax in codesTax"
                              :key="codetax.id"
                              :value="codetax.id"
                            >
                            {{ codetax.id }} - {{ codetax.name }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group col-md-2" v-show="permission || isPrivate">
                          <label for="service_value">Valor do atendimento:</label>
                          <input
                            id="service_value"
                            type="text"
                            class="form-control text-right"
                            placeholder="Ex: 70"
                            v-model="service.service_value"
                            @input="formatInputFloat($event,service,'service_value')"
                          />
                        </div>
                        <div
                          class="form-group col-md-2"
                          v-show="(permission || isPrivate) && !(this.service.agreement && this.service.agreement.is_private)"
                        >
                          <label for="coparticipation_amount">Valor Coparticipação:</label>
                          <input
                            id="coparticipation_amount"
                            type="text"
                            class="form-control text-right"
                            placeholder="Digite o valor"
                            v-model="service.coparticipation_amount"
                            @input="formatInputFloat($event,service,'coparticipation_amount')"
                          />
                        </div>
                        <div class="form-group col-md-2" v-show="permission">
                          <label for="transfer_amount">Valor do repasse:</label>
                          <input
                            id="transfer_amount"
                            type="text"
                            class="form-control text-right"
                            placeholder="0,00"
                            v-model="service.transfer_amount"
                            @input="formatInputFloat($event, service, 'transfer_amount')"
                          />
                        </div>
                        <div class="form-group col-md-2">
                          <label for="tipo_pagamento_id">Tipo Pagamento</label>
                          <Multiselect
                            :options="tiposPagamento"
                            v-model="selectedTipoPagamento"
                            @input="onTipoPagamentoSelecionado"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :track-by="'id'"
                            :label="'tiponome'"
                            deselect-label=""
                            select-label=""
                            placeholder="Selecione"
                          >
                            <template slot="singleLabel" slot-scope="props">
                              <strong>{{ props.option.id }}</strong> - {{ props.option.tiponome }}
                            </template>
                            <template slot="option" slot-scope="props">
                              <strong>{{ props.option.id }}</strong> - {{ props.option.tiponome }}
                            </template>
                          </Multiselect>
                        </div>
                      </div>
                    </tab-content>
                </FormWizard>
            </div>
        </div>
    </div>
  </div>
</template>

<style>
.w-12 {
  width: 3rem;
}
.h-12 {
    height: 3rem;
}
.text-lg {
    font-size: 1.900rem;
    line-height: 1.75rem;
}
.rounded-full {
    border-radius: 9999px;
}
.justify-center {
    justify-content: center;
}
.font-semibold {
    font-weight: 600;
}
.items-center {
    align-items: center;
}
.pt-8 {
    padding-top: 0.5rem;
}
.max-h-96 {
    max-height: 24rem;
}
.overflow-y-auto {
    overflow-y: auto;
}
.cursor-pointer {
    cursor: pointer;
}
.text-slate-400 {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.capitalize {
    text-transform: capitalize;
}
.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
</style>
